import { createContext, useContext } from 'react'

// Ниже этой ширины приложение живёт как мобильное: внизу вкладки, наверху
// название раздела, меню - на весь экран
export const MOBILE_QUERY = '(max-width:899px)'

// actionSlot - узел в верхней панели, куда страницы выносят свою главную
// кнопку («Добавить ...»). navItems - пункты меню с учётом прав: их считает
// Sidebar, а вкладки и заголовок только читают, чтобы не дублировать права
export const MobileShellContext = createContext({
  actionSlot: null,
  navItems: [],
  setNavItems: () => {},
})

export const useMobileShell = () => useContext(MobileShellContext)

const segmentsOf = (pathname = '') => pathname.split('/').filter(Boolean)

const isIdLike = (segment = '') => /^\d+$/.test(segment) || /^[0-9a-f-]{16,}$/i.test(segment)

// Страницы вне меню: название берём по первому сегменту адреса
const STATIC_TITLES = {
  settings: 'Настройки',
  unit: 'Байк',
  request: 'Заявка',
  iot: 'IoT-устройство',
  telegram: 'Telegram',
  geofences: 'Геозоны',
  'client-hubs': 'Точки',
  'design-system': 'Аналитика',
}

const sameRoot = (a, b) => segmentsOf(a)[0] === segmentsOf(b)[0]

// Что показать в верхней панели на этой странице: название раздела, нужна ли
// кнопка «назад» (страница не из верхнего уровня меню) и к какому пункту меню
// относится страница
export const resolveMobileView = (pathname, navItems = []) => {
  const segments = segmentsOf(pathname)
  const root = segments[0] || ''

  const item = navItems.find((candidate) => (
    (candidate.link && sameRoot(candidate.link.pathname, pathname))
    || candidate.childrens?.some((child) => sameRoot(child.link.pathname, pathname))
  ))

  // Подраздел: «Приглашения» внутри «Курьеров», «Тарифы» внутри «Аренд».
  // Название «Список» ничего не говорит - тогда берём название раздела
  const child = item?.childrens?.find((candidate) => (
    candidate.link.pathname.replace(/\/$/, '') === pathname.replace(/\/$/, '')
  ))
  const childTitle = child && child.title !== 'Список' ? child.title : null

  // Раздел из меню - верхний уровень, пока в адресе нет номера; всё, чего в
  // меню нет (настройки, карточка байка), открыто «поверх» и ведёт назад
  let isDetail
  if (segments.length === 0) isDetail = false
  else if (!item) isDetail = true
  else if (segments.length === 1) isDetail = false
  else if (segments.length === 2) isDetail = isIdLike(segments[1])
  else isDetail = true

  const title = childTitle || item?.title || STATIC_TITLES[root] || ''

  return { title, isDetail, item }
}

// Какие разделы выносим во вкладки внизу: приоритет задаёт роль и тип бизнеса
// (core/helpers/business-profile.js), а берутся только доступные человеку.
// Если доступных из списка меньше четырёх, добираем из общего порядка
const TAB_FALLBACK = ['/fleet', '/rents', '/drivers', '/tasks', '/work-orders', '/requests', '/warehouse', '/payments', '/dashboard']

export const pickTabItems = (navItems = [], priority = TAB_FALLBACK, limit = 4) => {
  const picked = []
  ;[...priority, ...TAB_FALLBACK].forEach((root) => {
    if (picked.length >= limit) return
    const found = navItems.find((candidate) => (
      candidate.link ? sameRoot(candidate.link.pathname, root) : candidate.childrens?.some((child) => sameRoot(child.link.pathname, root))
    ))
    if (found && !picked.includes(found)) picked.push(found)
  })
  return picked
}

// Куда вести вкладку: у раздела с подпунктами - в первый подпункт
export const itemTarget = (item) => item.link || item.childrens?.[0]?.link
